import React from 'react';

import CircularProgress from '@mui/material/CircularProgress';

export interface SpinnerProps {
  size?: string;
}

const Spinner: React.FC<SpinnerProps> = ({ size = '24px' }) => {
  return <CircularProgress style={{ margin: '0 auto' }} color="inherit" size={size} />;
};

export default Spinner;
